export enum AvatarWrapperTypes {
  SQUARE,
  CIRCLE,
}

export enum AvatarTypes {
  IMAGE,
  TEXT,
  ICON,
}

export interface AvatarCommonProps {
  size?: number
  color?: string
}

export interface AvatarProps {
  avatar?: string
  icon?: string
  name?: string
  size?: number
  color?: string

  type?: AvatarWrapperTypes

  /** 方形头像圆角 */
  squareRadius?: number

  /** 背景色（image 失败 / icon / text） */
  backgroundColor?: string

  /** 点击事件 */
  onClick?: () => void

  /** 容器宽高，默认跟随 size */
  width?: number | string
  height?: number | string
}

export interface ImageAvatarProps extends AvatarCommonProps {
  uri: AvatarProps["avatar"]
  onError?: () => void
  onLoad?: () => void
  onLoadStart?: () => void
  onLoadEnd?: () => void
}

export interface TextAvatarProps extends AvatarCommonProps {
  name: AvatarProps["name"]
}

export interface IconAvatarProps extends AvatarCommonProps {
  icon: AvatarProps["icon"]
}
